export default __webpack_public_path__ + "static/media/Photos 2.3e24d5a6.jpg";